import {toast} from "react-toastify";
import moment from "moment";

export enum ToastType {
    SUCCESS = "success",
    ERROR = "error",
    INFO = "info",
}

export const cToast = (str: string, type: ToastType) => toast[type](str, {toastId: str + moment().unix()});